export enum OperacionCFTipo {
    Prospecto = 1,
    Cliente = 2
}